import 'babel-polyfill'
import './utils'
import './prototype'
import './components'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './assets/fonts/iconfont.css'

// import vConsole from 'vconsole'
// new vConsole()

// 请求用户信息
store.dispatch('userInfo/getCurrentUserInfo')

// create app
const app = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})

window.Vue = Vue
window.$app = app

export default app



// WEBPACK FOOTER //
// ./src/main.js